var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 448 448",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.133 252.535-21.2-2.668A208.943 208.943 0 0 0 426.536 224c0-8.535-.535-17.2-1.601-25.734l21.199-2.664c1.199 9.332 1.734 18.933 1.734 28.398.133 9.602-.535 19.2-1.734 28.535zM404.398 356.668 387.2 344c10.133-13.867 18.535-28.8 24.934-44.668l19.867 8c-7.066 17.469-16.266 34.133-27.602 49.336zM317.2 427.734l-8.934-19.336c15.601-7.199 30.27-16.265 43.601-27.066l13.465 16.535a224.74 224.74 0 0 1-48.133 29.867zM150.535 323.2l-15.07-15.2 77.867-77.734V85.332h21.336v153.734zM448 149.332H341.332V128h85.336V42.668H448zm0 0",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 448C100.535 448 0 347.465 0 224S100.535 0 224 0c61.066 0 118.133 24.133 160.668 68l60.398 63.332L429.602 146l-60.27-63.2C330.934 43.2 279.199 21.333 224 21.333 112.266 21.332 21.332 112.266 21.332 224S112.266 426.668 224 426.668c11.867 0 23.867-1.066 35.465-3.066l3.734 21.066C250.4 446.801 237.2 448 224 448zm0 0",
    fill: "#FFFFFF",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4785f55ff90c87c951c260a59a8dd80d.svg";
export { ForwardRef as ReactComponent };